import React, { useContext, useState, ReactChild } from 'react';
import { IComponentGuests, IOneGuest } from '../../component';
import Guests from '../ButtonGroup/Guests';
import './AllForGuests.scss';
import { getNameByType } from '../ButtonGroup/AllForButtonGroup';
import { ThemeContext } from '../../store/ThemeProvider';
import BottomModal from '../ButtonGroup/BottomModal';
import intl from 'react-intl-universal';
import { style } from '../../utils/image';
import { getCompatibleCls } from '../../utils/dom';

const AllForGuests = function(props: IComponentGuests) {
  const { h1Color } = useContext(ThemeContext);

  const [showModal, setShowModal] = useState(false);
  const [modalChild, setModalChild] = useState('' as ReactChild);

  const showItem = (one: IOneGuest) => {
    setModalChild(
      <div className="modal-guest-detail">
        <img className="photo" src={style(one.photo, 'wx_250_160')} />
        <div className="name">{one.name}</div>
        <div className="desc-title">{intl.get('Intro')}</div>
        <div className="desc">{one.desc}</div>
      </div>
    );
    setShowModal(true);
  };

  const { title, api } = props;

  const cls = getCompatibleCls('all-for-guests', api);

  return (
    <div className={cls}>
      {typeof title != 'undefined' && !title ? null : (
        <div className="title" style={{ color: h1Color }}>
          {typeof title == 'undefined' ? getNameByType('guest-intro') : title}
        </div>
      )}
      <Guests {...props} onItemClick={showItem} />

      <BottomModal
        title={intl.get('More')}
        show={showModal}
        onHide={() => setShowModal(false)}
        child={modalChild}
      />
    </div>
  );
};

export default AllForGuests;
